import { useMutation } from "@apollo/client";
import { useCallback, useState } from "react";

import { PlannerV2_GetPendingChangesDocument } from "../../queries.generated";
import { PlannerV2TravelGroupCancelDocument } from "../mutations.generated";
import { PlannerV2FieldworkersGetPlannableForVisitDocument, PlannerV2VisitGetByIdDocument } from "../queries.generated";

export default function usePlannerV2CancelTravelGroup() {
    const [isCancelingGroupId, setIsCancelingGroupId] = useState<string | undefined>(undefined);
    const [mutate, { data, loading, error }] = useMutation(PlannerV2TravelGroupCancelDocument, {
        refetchQueries: [
            PlannerV2VisitGetByIdDocument,
            PlannerV2FieldworkersGetPlannableForVisitDocument,
            PlannerV2_GetPendingChangesDocument,
        ],
        awaitRefetchQueries: true,
    });

    const cancelTravelGroup = useCallback(
        async (plannerTravelGroupId: string) => {
            setIsCancelingGroupId(plannerTravelGroupId);
            try {
                await mutate({
                    variables: {
                        input: { plannerTravelGroupId },
                    },
                });
            } finally {
                setIsCancelingGroupId(undefined);
            }
        },
        [mutate],
    );

    return {
        cancelTravelGroup,
        loading,
        isCancelingGroupId,
        error,
        data,
    };
}
